module.exports = __webpack_public_path__ + "img/scene3.b116380c.png";